import React from 'react';

import useMeetSanction from './UseMeetSanction';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';
import MeetSanctionGrid from '../components/grids/meetSanctionGrid/MeetSanctionGrid';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const MeetSanction = () => {
  const {
    location,
    Constants,
    meetSanctionState,
    onSanctionClicked
  } = useMeetSanction();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={`Meet Sanction Request Queue${location.state?.isRevisit === true? ' - Requires Revisit' : ' - New Requests'}`}>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <MeetSanctionGrid
              data={meetSanctionState.arrayData}
              isLoading={meetSanctionState.isArrayLoading}
              onSanctionClicked={onSanctionClicked} />
          </div>
        </div>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={meetSanctionState.isArrayLoading} />
      </WorkFlowNavigation>
    </div>
  );
};

export default MeetSanction;